import { Capacitor } from '@capacitor/core';

export const APP_REFRESH_EVENT = 'pacarion-app-refresh';

/**
 * Homeowner tasks and projects are loaded through the homeowner API, not a
 * table the signed-in Supabase session can subscribe to. Refetch on resume,
 * visibility, and push instead of a realtime channel that would not see them.
 */
export function publishAppRefresh(reason) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(APP_REFRESH_EVENT, {
    detail: { reason: reason || '' },
  }));
}

export async function installAppRefresh() {
  if (typeof document === 'undefined') return () => {};
  const onVisible = () => {
    if (document.visibilityState === 'visible') publishAppRefresh('visible');
  };
  document.addEventListener('visibilitychange', onVisible);
  const handles = [];
  if (Capacitor.isNativePlatform()) {
    try {
      const { App } = await import('@capacitor/app');
      handles.push(await App.addListener('resume', () => publishAppRefresh('resume')));
      handles.push(await App.addListener('appStateChange', (state) => {
        if (state && state.isActive) publishAppRefresh('active');
      }));
    } catch (error) {
      // The native plugin is available after the iOS project syncs @capacitor/app.
    }
  }
  return () => {
    document.removeEventListener('visibilitychange', onVisible);
    handles.forEach((handle) => {
      if (handle && handle.remove) handle.remove();
    });
  };
}
